<h2 class="heading-4">Your repair</h2>

<section>
  <p class="body">{{ vm.repairer }} has its own repair booking system</p>
  <p class="body">To book a repair, please contact them directly and they'll be happy to help.</p>

  <app-telephone-link
    [phoneNumber]="'020 1234 1234'"
    postCodeMessagingClasses="max-w-480"
    [largeFont]="true"
    [postCode]="'PE29 1ZA'"
    class="mt-12"
  />

  <section class="other-links mt-20">
    @if (vm.website && vm.website !== '') {
      <section>
        <p class="label">Website</p>
        <p class="body mt-8">
          <i class="fa-regular fa-mouse mr-8"></i>
          <a [href]="vm.website" class="link-text" target="_blank">{{ vm.website }}</a>
        </p>
      </section>
    }

    @if (vm.email && vm.email !== '') {
      <section>
        <p class="label">Email</p>
        <p class="body mt-8">
          <a href="mailto:{{ vm.email }}" class="link-text" target="_blank">{{ vm.email }}</a>
        </p>
      </section>
    }
  </section>
</section>
